export class TripCommentModel {
  tripId: string;
  tripComment: string;
  TripCommentBy: string;
  TripCommentOn: string;
  TripCommentByFullname: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdatareport/models/tripcomment.model.ts